import React from 'preact/compat';
import { memo } from 'preact/compat';
import Box from '@mui/material/Box';

import LoadingIcon from '../icons/LoadingIcon';

const Loading = memo(() => {
    return (
        <Box
            sx={{
                margin: 'auto',
                marginTop: '50px',
                marginBottom: '40px',
                width: '44px'
            }}
        >
            <LoadingIcon sx={{ fontSize: '44px', color: '#FFFFFF' }} className="loading-image" />
        </Box>
    )
});

export default Loading;
